var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgApartmentCategory8(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28.68,
    height: 28.68,
    viewBox: "0 0 28.68 28.68",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "apartment_24dp_E8EAED_FILL1_wght300_GRAD0_opsz24",
    d: "M130-808.24v-22.124h6.555v-6.555h15.569v13.111h6.555v15.569H146.388V-814.8h-4.1v6.555Zm2.458-2.458h4.1v-4.1h-4.1Zm0-6.555h4.1v-4.1h-4.1Zm0-6.555h4.1v-4.1h-4.1Zm6.555,6.555h4.1v-4.1h-4.1Zm0-6.555h4.1v-4.1h-4.1Zm0-6.555h4.1v-4.1h-4.1Zm6.555,13.111h4.1v-4.1h-4.1Zm0-6.555h4.1v-4.1h-4.1Zm0-6.555h4.1v-4.1h-4.1Zm6.555,19.666h4.1v-4.1h-4.1Zm0-6.555h4.1v-4.1h-4.1Z",
    transform: "translate(-130 836.92)",
    fill: "#85899c"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApartmentCategory8);
export default __webpack_public_path__ + "static/media/apartment_category_8.1911a5b6049b7414a0309ab0d4c6350e.svg";
export { ForwardRef as ReactComponent };